import { Button } from 'primereact/button'
import { InputNumber, InputNumberValueChangeEvent } from 'primereact/inputnumber'
import { InputTextarea } from 'primereact/inputtextarea'
import { RadioButton } from 'primereact/radiobutton'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router'
import * as myconst from "../../constants"

interface dimensionsType {
    width: number,
    height: number,
}
interface suggestionObject {
    output_image_id: string
    output_path: string
    prompt: string
}
interface suggestionImagesResponse {
    conversation_id: string,
    extension: string,
    input_image_id: string,
    input_path: string,
    suggestion_object: suggestionObject[];
    user_name: string,
}
interface ImageData {
    conversation_id: string,
    input_image_id: string,
    output_image_id: string[],
    user_name: string,
    image_extension: string,
    input_path: string,
    output_path: string[],
    system_prompt: string,
    notes: string,
    tag: string[],
    size?: string,
    cust_height?: number,
    cust_width?: number,
    created_at: string,
    title?: string,
    is_save: boolean
}
interface DescribeType {
    activeImage: string
    isTextAreaValid: boolean
    setResize: React.Dispatch<React.SetStateAction<string>>;
    resize: string;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    componentName: string
    setInputValue: React.Dispatch<React.SetStateAction<string>>;
    inputValue: string;
    handleGenerate: () => Promise<void>;
    setImageSize?: React.Dispatch<React.SetStateAction<string>>;
    imageSize?: string;
    setCustomHeight?: React.Dispatch<React.SetStateAction<number>>;
    customHeight?: number;
    setCustomWidth?: React.Dispatch<React.SetStateAction<number>>;
    customWidth?: number;
    dimensions?: dimensionsType
    suggestionValue?: suggestionImagesResponse;
    setActiveImage: React.Dispatch<React.SetStateAction<string>>;
    setImageData: React.Dispatch<React.SetStateAction<ImageData>>;
    setActiveClassImageDescribe: React.Dispatch<React.SetStateAction<string>>;
    activeClassImageDescribe: string;
    activateSuggestion: boolean;
}

const DescribeSection = ({ setImageData, setActiveImage, suggestionValue, isTextAreaValid, handleGenerate, setResize, resize, setVisible, componentName, setInputValue, inputValue, setImageSize, imageSize, setCustomWidth, customWidth, setCustomHeight, customHeight, dimensions, activeImage, setActiveClassImageDescribe, activeClassImageDescribe, activateSuggestion }: DescribeType) => {
    const navigate = useNavigate();
    const elementRef: any = useRef(null);
    const apiUrl = process.env.RON_LENS_IMAGE || (window.location.origin === 'https://ron.rysun.in:3001' || window.location.origin === 'https://shoptalk.rysun.com') ? "https://ronimages.rysun.in/" : 'http://43.242.38.46/';
    const handleSize = (img: string) => {
        if (setImageSize && activeImage !== "" && activeImage !== 'data:undefined;base64,') {
            setImageSize(img)
        }
    }
    const textChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (e.target.value.length <= 175) {
            setInputValue(e.target.value);
            setVisible(false)
        } else {
            setInputValue(e.target.value.slice(0, 175));
            setVisible(false)
        }
    }
    const handleDescribeText = () => {
        switch (componentName) {
            case 'ron_lens_instance_change':
                return "Describe the color of the element you want to change";
            case 'ron_lens_background_change':
                return 'Describe the background you want to create';
            case 'ron_lens_image_expansion':
                return 'Describe the background you want to create'
        }
    }
    const handlePlaceholderText = () => {
        switch (componentName) {
            case 'ron_lens_instance_change':
                return "Example: Change the T-Shirt color to Black";
            case 'ron_lens_background_change':
                return 'Example: A lush green forest with sunlight filtering through the leaves';
            case 'ron_lens_image_expansion':
                return 'Example: A majestic mountain range with snow capped peaks'
        }
    }
    const handleLensModule = () => {
        switch (componentName) {
            case 'ron_lens_image_expansion':
                return "image-extender";
            case 'ron_lens_background_change':
                return "smart-background";
            case 'ron_lens_instance_change':
                return "generate-instance"
        }
    }
    const handleSuggestionClick = (obj: suggestionObject) => {
        const body: any = {
            conversation_id: suggestionValue?.conversation_id,
            input_image_id: suggestionValue?.input_image_id,
            output_image_id: [obj?.output_image_id],
            user_name: suggestionValue?.user_name,
            image_extension: suggestionValue?.extension,
            input_path: suggestionValue?.input_path,
            output_path: [obj?.output_path],
            system_prompt: obj?.prompt,
            notes: "",
            tag: [""],
            title: null,
            created_at: "",
            is_save: false
        }
        setVisible(false)
        if (componentName === "ron_lens_image_expansion") {
            setResize("Ratio");
            body.size = "1:1";
            body.cust_height = 0;
            body.cust_width = 0;
        }
        setImageData(body);
        myconst.imageToBase64(obj?.output_path?.replace("/var/www/html/", apiUrl), setActiveImage);
        setInputValue(obj?.prompt);
        navigate(`/lens/${handleLensModule()}?conversation_id=${suggestionValue?.conversation_id}&input_image_id=${suggestionValue?.input_image_id}`)
    }

    useEffect(() => {
        if (elementRef.current) {
            elementRef.current.scrollTop = 0;
        }
    }, [suggestionValue])

    return (
        <div className='describe-image-sidebar'>
            <div className='describe-area'>
                <b>{handleDescribeText()}</b>
                <InputTextarea disabled={activeImage === "" || activeImage === 'data:undefined;base64,'} className={isTextAreaValid ? "border-red" : ""} value={inputValue} onChange={textChange} placeholder={handlePlaceholderText()} />
                <span className='float-end' style={{ fontSize: "12px" }}>{`${inputValue.length}/175`}</span>
            </div>
            {/* <p className='helper-text2'><i className="pi pi-exclamation-triangle"></i>Only <b>175 characters</b> are allowed.</p> */}
            {
                componentName === "ron_lens_image_expansion" &&
                <div className="resize-area mt-3">
                    <div className="resize-fix">
                        <RadioButton disabled={activeImage === "" || activeImage === 'data:undefined;base64,'} className='c-pointer' inputId="val1" name="resize" value="Ratio" onChange={(e) => setResize(e.value)} checked={resize === 'Ratio'} />
                        <label htmlFor="val1" className={activeImage !== 'data:undefined;base64,' ? 'c-pointer' : ""}>Ratio</label>
                        {
                            resize === "Ratio" &&
                            <ul className="choose-ratio">
                                <li onClick={() => handleSize("1:1")} style={{ pointerEvents: activeImage === "" || activeImage === 'data:undefined;base64,' ? "none" : "auto", opacity: activeImage === "" || activeImage === 'data:undefined;base64,' ? "0.5" : "" }} className={imageSize === "1:1" ? "active-shape" : ""}>
                                    <div className="shape shape-1-1"></div>
                                    <span>1:1</span>
                                </li>
                                <li onClick={() => handleSize("16:9")} style={{ pointerEvents: activeImage === "" || activeImage === 'data:undefined;base64,' ? "none" : "auto", opacity: activeImage === "" || activeImage === 'data:undefined;base64,' ? "0.5" : "" }} className={imageSize === "16:9" ? "active-shape" : ""}>
                                    <div className="shape shape-16-9"></div>
                                    <span>16:9</span>
                                </li>
                                <li onClick={() => { handleSize("9:16") }} style={{ pointerEvents: activeImage === "" || activeImage === 'data:undefined;base64,' ? "none" : "auto", opacity: activeImage === "" || activeImage === 'data:undefined;base64,' ? "0.5" : "" }} className={imageSize === "9:16" ? "active-shape" : ""}>
                                    <div className="shape shape-9-16"></div>
                                    <span>9:16</span>
                                </li>
                            </ul>
                        }
                    </div>
                    <div className="resize-custom">
                        <RadioButton disabled={activeImage === "" || activeImage === 'data:undefined;base64,'} className='c-pointer' inputId="val2" name="resize" value="Custom" onChange={(e) => setResize(e.value)} checked={resize === 'Custom'} />
                        <label className={activeImage !== 'data:undefined;base64,' ? 'c-pointer' : ""} htmlFor="val2">Custom</label>
                        {
                            resize === "Custom" &&
                            <>
                                <div className="resize-custom-input-wrap">
                                    <div className="resize-custom-input">
                                        <span>Width</span>
                                        <InputNumber value={customWidth} disabled={activeImage === "" || activeImage === 'data:undefined;base64,'} min={0} onValueChange={(e: InputNumberValueChangeEvent) => { if (setCustomWidth) { setCustomWidth(Number(e?.value)) } }} placeholder="px" useGrouping={false} suffix=" px" />
                                    </div>
                                    <div className="resize-custom-input">
                                        <span>Height</span>
                                        <InputNumber value={customHeight} disabled={activeImage === "" || activeImage === 'data:undefined;base64,'} min={0} onValueChange={(e: InputNumberValueChangeEvent) => { if (setCustomHeight) { setCustomHeight(Number(e?.value)) } }} placeholder="px" useGrouping={false} suffix=" px" />
                                    </div>
                                </div>
                                <p className='helper-text2'><i className="pi pi-exclamation-triangle"></i>Custom width and height must be greater than the specified dimensions <b>{dimensions?.width}</b> x <b>{dimensions?.height}</b> px.</p>
                            </>
                        }
                    </div>
                </div>
            }
            <div className="generate-btn">
                <Button label="Generate" disabled={activeImage === "" || activeImage === 'data:undefined;base64,'} onClick={handleGenerate} className="outline-btn" style={{ border: inputValue.length === 0 ? "1px solid #ACACAC" : "1px solid #5627D9" }} />
            </div>
            {
                componentName === "ron_lens_background_change" && !activateSuggestion && activeImage !== "" && activeImage !== 'data:undefined;base64,' &&
                <div className='suggested-main'>
                    <h6>Background Suggestions</h6>
                    <div className='suggested-wrap'>
                        <ul className={`suggested-list`} ref={elementRef}>
                            {/* <ul className={`suggested-list ${componentName === "ron_lens_image_expansion" ? "extender-img-list" : ""}`}> */}
                            {suggestionValue?.suggestion_object?.map((img: suggestionObject, i: number) => (
                                <li key={img?.output_image_id} className={activeClassImageDescribe === img?.output_image_id ? "active-suggestion" : ''}>
                                    <span onClick={() => { handleSuggestionClick(img); setActiveClassImageDescribe(img?.output_image_id) }}>
                                        <img src={img?.output_path?.replace("/var/www/html/", apiUrl)} alt="suggestion image" />
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            }
        </div>
    )
}

export default DescribeSection